import { StyleDictionary } from "pdfmake/interfaces";
import { DocumentPdfDefaultColumn } from "./types";

export const DOCUMENT_PDF_DEFAULT_COLUMNS = [
	DocumentPdfDefaultColumn.POSITION,
	DocumentPdfDefaultColumn.NAME,
	DocumentPdfDefaultColumn.VOLUME,
	DocumentPdfDefaultColumn.QUANTITY,
	DocumentPdfDefaultColumn.TOTAL_VOLUME,
	DocumentPdfDefaultColumn.TAX,
];

export const A4WIDTH = 595;

export const DOCUMENT_PDF_TABLE_STYLES: StyleDictionary = {
	bold: {
		bold: true,
	},
	header: {
		fontSize: 18,
		bold: true,
		alignment: "center",
	},
	table: {
		margin: [0, 20, 0, 0],
	},
	tableHeader: {
		bold: true,
		fontSize: 10,
		color: "#333a38",
	},
	tableCell: {
		bold: false,
		fontSize: 9,
		color: "#464e4c",
	},
	rightCorner: {
		fontSize: 11,
		alignment: "right",
	},
	label: {
		fontSize: 10,
		bold: true,
	},
	value: {
		fontSize: 10,
	},
	pricesTop: {
		margin: [0, 10, 0, 0],
	},
	prices: {
		alignment: "right",
		fontSize: 10,
	},
	separator: {
		margin: [0, 0, 0, 10],
	},
};
